import { Card, Row } from "antd";
import { FormContainer } from "./FormContainer";

export const GeneralTab = () => {
  return (
    <Row className="general-settings">
      <Row className="d-block w-100 py-6 pr-8 pl-2">
        <Card className="h-100">
          <Row className="w-100">
            <h5 className="h h5 ant-table-title">Accounts</h5>
          </Row>
          <Row className="w-100 mt-6">
            <p className="my-0 text-md title">Next Auto-Generated Account #</p>
          </Row>
          <FormContainer />
        </Card>
      </Row>
    </Row>
  );
};
